import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import eventService from "@/services/mrfiktiv/services/eventService";
import { MrfiktivEventControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, getModule } from "vuex-module-decorators";
import { BasePagination, IPaginationFilterListElement } from "./base-pagination.store";
import { EventUIDto } from "@/lib/dto/event/event-ui.dto";

/**
 * wraps the timed event endpoint into a makeshift event pagination @see RefTypeMap
 */
@Module({
  dynamic: true,
  namespaced: true,
  name: "event-reference-store",
  store
})
export class EventReferenceStore extends BasePagination<EventUIDto, MrfiktivEventControllerGetParamsGen> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 1;
  protected _totalPages = 1;
  protected _paginationList: EventUIDto[] = [];
  protected _currentPage = 1;
  protected _totalItems = 1;
  protected _isLoadAll = false;
  filterOptions: IPaginationFilterListElement[] = [];

  @Action
  protected async loadDocuments(query: MrfiktivEventControllerGetParamsGen) {
    const res = await eventService.listAll({
      from: new Date(new Date().getFullYear(), new Date().getMonth() - 1).getTime(),
      to: new Date(new Date().getFullYear(), new Date().getMonth() + 2).getTime(),
      partnerId: query.partnerId
    });

    return {
      data: res,
      meta: {
        // this is a fake pagination
        currentPage: 1,
        itemsPerPage: 1,
        totalItems: 1,
        totalPages: 1
      }
    };
  }

  @Action
  addToList(document: EventUIDto): void {
    const index = this._paginationList.findIndex(x => x.id === document.id);
    if (index >= 0) {
      this._paginationList.splice(index, 1, document);
    } else {
      this._paginationList.push(document);
    }
  }
}

export const EventReferenceModule = getModule(EventReferenceStore);
